
import { defineComponent, computed, watch, ref, onMounted } from 'vue';
import store from '@/store';
import router from '@/router';
export default defineComponent({
  setup() {
    const logout = () => {
      store.commit('logout');
    };
    const userName = ref('');
    onMounted(() => {
      userName.value = store.state.userInfo.username;
    });
    const isLogin = computed(() => {
      return store.state.userInfo.isLogin;
    });
    watch(isLogin, (newValue, oldValue) => {
      if (!newValue && oldValue) {
        router.push('/main');
      }
    });
    return {
      userName,
      logout,
      isLogin,
    };
  },
});
